import { Suspense, useEffect, useState } from "react";
import "./App.css";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Allroutes } from "./routes/Allroutes";
import ScrollToTop from "./components/ScrollToTop";
import ScrollRestore from "./components/ScrollRestore";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [language, setLanguage] = useState("en");
  const [FormComponent, setFormComponent] = useState(null);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  const toggleForm = () => setIsFormOpen((prev) => !prev);

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "ar" : "en"));
  };

  useEffect(() => {
    if (FormComponent) return undefined;

    let cancelled = false;

    import("./components/form")
      .then((mod) => {
        if (!cancelled) setFormComponent(() => mod.Form);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [FormComponent]);

  return (
    <div>
      <Header
        openForm={openForm}
        language={language}
        toggleLanguage={toggleLanguage}
      />
      <ScrollRestore />
      <ScrollToTop />
      <Allroutes language={language} />
      <Footer
        openForm={openForm}
        language={language}
        toggleLanguage={toggleLanguage}
      />
      {FormComponent && (
        <ErrorBoundary fallbackTitle="Contact form unavailable">
          <Suspense fallback={null}>
            <FormComponent
              isFormOpen={isFormOpen}
              openForm={openForm}
              closeForm={closeForm}
              toggleForm={toggleForm}
              setIsFormOpen={setIsFormOpen}
              language={language}
              toggleLanguage={toggleLanguage}
            />
          </Suspense>
        </ErrorBoundary>
      )}
    </div>
  );
}

export default App;
